import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

const SixteenNine = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 9">
      <rect x="0" y="0" width="16" height="9" />
    </SvgIcon>
  );
};

export default SixteenNine;
